module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-2-eb2f169997567d8076371abad846717b.gif";